<template>
    <div class="content-container-white">
        <ModuleHeader title="Neuer Kunde"/>
        <div class="container">

            <div v-if="saveError" class="error">
                <div class="mb-4">{{ saveError }}</div>
                <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
            </div>


            <div v-if="!saveError">
                <customer-form :onSaveCallback="createCustomer" :onSaveAndNextCallback="createCustomerAndAddNew"/>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomerForm from "components/customer/CustomerForm";
    import ModuleHeader from "components/util/ModuleHeader";
    import slugify from "slugify";
    import db from 'firedb/db';

    export default {
        name: "Create",

        components: {ModuleHeader, CustomerForm},

        data: function() {
            return {
                saveError: null
            }
        },
        methods: {

            createCustomer(customer) {

                customer.slug = slugify(customer.name, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@#]/g,
                    lower: true
                });

                db.create('customer',
                    customer
                ).then(result => {
                    this.$router.replace('/app/customer');
                }).catch(e => {
                    console.error(e);
                    this.saveError = "Kunde konnte nicht erstellt werden."
                });
            },

            createCustomerAndAddNew(customer) {

                customer.slug = slugify(customer.name, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@#]/g,
                    lower: true
                });

                return db.create('customer',
                    customer);
            }
        }
    }
</script>

<style scoped lang="scss">

    .buttons {
        margin-top: 2rem;
    }
</style>